import { render, staticRenderFns } from "./Handleiding.vue?vue&type=template&id=88fcc672&scoped=true"
import script from "./Handleiding.vue?vue&type=script&lang=js"
export * from "./Handleiding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88fcc672",
  null
  
)

export default component.exports